<template>
    <b-button
    class="default-portfolio-button"
    label="Generate Report"
    type="is-primary"
    icon-pack="fas"
    icon-left="file-pdf"
    v-on:click="goToReportBuilder(portfolio)"
    />
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      portfolio: Object,
    },
    methods: {
      goToReportBuilder: function(portfolio) {
        let portfolioId = this.portfolio.default_portfolio != undefined ? this.portfolio.default_portfolio.id : null
        let params = {
          values_from: this.prospect.id,
          reporting: portfolioId != null ? portfolioId : '',
          dollarsOrPercentages: 'dollars',
        }
        window.location.href = `/ui/advisor/reports/?${new URLSearchParams(params)}`;
      },
    }
  }
</script>

<style>
</style>